import crudRouteCreation from "./crud"

const enableTestRoutes = !!process.env.VUE_APP_DEVELOPMENT_MODE
const testComponentRoutes = enableTestRoutes
  ? [
      {
        path: "/tests",
        name: "Tests.Home",
        component: () => import("../views/pages/tests/overview.vue"),
        meta: { title: "Tests" }
      },
      {
        path: "/tests/components/invoice-cost-input",
        name: "Tests.Components.InvoiceCostInput",
        component: () => import("../views/pages/tests/components/InvoiceCostInput.vue"),
        meta: { title: "Tests: Invoice Cost Input", group: "Invoicing" }
      },
      {
        path: "/tests/components/signup",
        name: "Tests.Components.Signup",
        component: () => import("../views/pages/tests/components/HarnessedSignup.vue"),
        meta: { title: "Tests: Signup", group: "Companies & accounts" }
      },
      {
        path: "/tests/components/invoice-step-line",
        name: "Tests.Components.InvoiceStepLine",
        component: () => import("../views/pages/tests/components/InvoiceStepLine.vue"),
        meta: { title: "Tests: Invoice Step Line", group: "Invoicing" }
      },
      {
        path: "/tests/components/invoice-job-line",
        name: "Tests.Components.InvoiceJobLine",
        component: () => import("../views/pages/tests/components/HarnessedInvoiceJobLine.vue"),
        meta: { title: "Tests: Invoice Job Line", group: "Invoicing" }
      },
      {
        path: "/tests/components/edit-invoice-view",
        name: "Tests.Components.EditInvoiceView",
        component: () => import("../views/pages/tests/components/EditInvoiceView.vue"),
        meta: { title: "Tests: Edit Invoice View", group: "Invoicing" }
      },
      {
        path: "/tests/components/generate-invoice-from-jobs-view",
        name: "Tests.Components.GenerateInvoiceFromJobsView",
        component: () => import("../views/pages/tests/components/GenerateInvoiceFromJobsView.vue"),
        meta: { title: "Tests: Generate Invoice From Jobs View", group: "Invoicing" }
      },
      {
        path: "/tests/components/generate-invoice-without-jobs-view",
        name: "Tests.Components.GenerateInvoiceWithoutJobsView",
        component: () => import("../views/pages/tests/components/GenerateInvoiceWithoutJobsView.vue"),
        meta: { title: "Tests: Generate Invoice Without Jobs View", group: "Invoicing" }
      },
      {
        path: "/tests/components/company-peppol-status",
        name: "Tests.Components.CompanyPeppolStatus",
        component: () => import("../views/pages/tests/components/HarnseedCompanyPeppolStatus.vue"),
        meta: { title: "Tests: Company Peppol Status", group: "Peppol" }
      },
      {
        path: "/tests/components/company-details/:id?",
        name: "Tests.Components.CompanyDetails",
        component: () => import("../views/pages/tests/components/HarnessedCompanyDetails.vue"),
        meta: { title: "Tests: Company Details", group: "Companies & accounts" }
      },
      {
        path: "/tests/components/peppol-participant-id-input",
        name: "Tests.Components.PeppolParticipantIdInput",
        component: () => import("../views/pages/tests/components/HarnessedPeppolParticipantIdInput.vue"),
        meta: { title: "Tests: Peppol Participant Id Input", group: "Peppol" }
      },
      {
        path: "/tests/components/access-point-document-status",
        name: "Tests.Components.AccessPointDocumentStatus",
        component: () => import("../views/pages/tests/components/AccessPointDocumentStatus.vue"),
        meta: { title: "Tests: Access Point Document Status", group: "Peppol" }
      },
      {
        path: "/tests/components/document",
        name: "Tests.Components.Document",
        component: () => import("../views/pages/tests/components/HarnessedDocument.vue"),
        meta: { title: "Tests: Document", group: "Documents" }
      },
      {
        path: "/tests/components/cmr-viewer",
        name: "Tests.Components.CmrViewer",
        component: () => import("../views/pages/tests/components/HarnessedCmrViewer.vue"),
        meta: { title: "Tests: CMR Viewer", group: "Documents" }
      },
      {
        path: "/tests/components/invoice-customer-details",
        name: "Tests.Components.InvoiceCustomerDetails",
        component: () => import("../views/pages/tests/components/InvoiceCustomerDetails.vue"),
        meta: { title: "Tests: Invoice Customer Details", group: "Invoicing" }
      },
      {
        path: "/tests/components/vat-input",
        name: "Tests.Components.VatInput",
        component: () => import("../views/pages/tests/components/VatInput.vue"),
        meta: { title: "Tests: Vat Input", group: "Pricing & VAT" }
      },
      {
        path: "/tests/components/applicable-vat-select",
        name: "Tests.Components.ApplicableVatSelect",
        component: () => import("../views/pages/tests/components/HarnessedApplicableVatSelect.vue"),
        meta: { title: "Tests: Applicable VAT Select", group: "Pricing & VAT" }
      },
      {
        path: "/tests/components/forex-calculator",
        name: "Tests.Components.ForexCalculator",
        component: () => import("../views/pages/tests/components/HarnessedForexCalculator.vue"),
        meta: { title: "Tests: Forex Calculator", group: "Pricing & VAT" }
      },
      {
        path: "/tests/components/send-with-peppol-button",
        name: "Tests.Components.SendWithPeppolButton",
        component: () => import("../views/pages/tests/components/SendWithPeppolButton.vue"),
        meta: { title: "Tests: Send With Peppol Button", group: "Peppol" }
      },
      {
        path: "/tests/components/send-with-peppol-view",
        name: "Tests.Components.SendWithPeppolView",
        component: () => import("../views/pages/tests/components/SendWithPeppolView.vue"),
        meta: { title: "Tests: Send With Peppol View", group: "Peppol" }
      },
      {
        path: "/tests/components/yard-job-view",
        name: "Tests.Components.YardJobView",
        component: () => import("../views/pages/tests/components/HarnessedYardJobView.vue"),
        meta: { title: "Tests: Yard Job View", group: "Operations" }
      },
      {
        path: "/tests/components/world-clock-view",
        name: "Tests.Components.WorldClockView",
        component: () =>
          import("../views/pages/tests/components/HarnessedWorldClockView.vue").then((m) => m.default || m),
        meta: { title: "Tests: World Clock View", group: "Operations" }
      },
      {
        path: "/tests/components/price-suggestion",
        name: "Tests.Components.PriceSuggestion",
        component: () => import("../views/pages/tests/components/HarnessedPriceSuggestion.vue"),
        meta: { title: "Tests: Price Suggestion", group: "Pricing & VAT" }
      },
      {
        path: "/tests/components/invoice-step-wait-time-line",
        name: "Tests.Components.InvoiceStepWaitTimeLine",
        component: () => import("../views/pages/tests/components/HarnessedInvoiceStepWaitTimeLine.vue"),
        meta: { title: "Tests: Invoice Step Wait Time Line", group: "Invoicing" }
      },
      {
        path: "/tests/mappers/document-type-to-icon",
        name: "Tests.Mappers.DocumentTypeToIcon",
        component: () => import("../views/pages/tests/mappers/DocumentTypeToIcon.vue"),
        meta: { title: "Tests: DocumentTypeToIcon", group: "Documents" }
      }
    ]
  : []

export default [
  {
    path: "/",
    name: "Index",
    redirect: "/planning",
    component: () => import("../views/layouts/Authenticated.vue"),
    children: [
      {
        path: "/map",
        name: "Map",
        component: () => import("../views/pages/map/map.vue"),
        meta: { titleKey: "map.route" }
      },
      // ...crudRouteCreation("Orders", "orders"),
      ...crudRouteCreation("Companies", "companies"),
      {
        path: "/companies/archived",
        name: "Companies.Archived",
        component: () => import("../views/pages/companies/list.vue"),
        props: { archived: true },
        meta: { titleKey: "companies.archiving.archivedCompanies", requiredPermission: "companies.view" }
      },
      ...crudRouteCreation("Drivers", "employees", (type) => {
        if (type === "list") {
          return import("../views/pages/employees/employees.vue")
        }
        return null
      }),
      {
        path: "/companies/details/:id/price-list",
        name: "Companies.PriceList",
        component: () => import("../views/pages/companies/price-list.vue"),
        meta: {
          titleKey: "priceSuggestions.priceList.title",
          requiredPermission: "invoices.view"
        }
      },
      ...crudRouteCreation("Locations", "locations"),
      {
        path: "/employees/calendar",
        name: "Employees.Calendar",
        component: () => import("../views/pages/employees/calendar.vue"),
        meta: { titleKey: "employees.route" }
      },
      {
        path: "/orders",
        name: "Orders",
        component: () => import("../views/pages/orders/orders.vue"),
        meta: { titleKey: "orders.route" }
      },
      {
        path: "/vehicles",
        name: "Vehicles",
        component: () => import("../views/pages/vehicles/vehicles.vue"),
        meta: { titleKey: "vehicles.route" }
      },
      {
        path: "/planning",
        name: "Plan",
        component: () => import("../views/pages/planning/overview.vue"),
        meta: { titleKey: "planning.route" }
      },
      {
        path: "/yard",
        name: "Yard",
        component: () => import("../views/pages/yard/yardPlanning.vue"),
        meta: { titleKey: "yard.route" }
      },
      {
        path: "/trade",
        name: "Trade",
        component: () => import("../views/pages/trade/tradePlanning.vue"),
        meta: { titleKey: "trade.route" }
      },
      {
        path: "/invoices",
        name: "invoices",
        component: () => import("../views/pages/invoices/invoices.vue"),
        meta: { titleKey: "invoices.route" }
      },
      {
        path: "/activityReports",
        name: "activityReports",
        component: () => import("../views/pages/activity-reports/activityReports.vue"),
        meta: { titleKey: "activityReports.route" }
      },
      {
        path: "/reports",
        name: "reports",
        component: () => import("../views/pages/reports/reports.vue"),
        meta: { titleKey: "reports.route" }
      },
      {
        path: "/mails",
        name: "mails",
        component: () => import("../views/pages/mails/mails.vue"),
        meta: { title: "Mails" }
      },
      {
        path: "/documents",
        name: "documents",
        component: () => import("../views/pages/documents/Documents.vue"),
        meta: { title: "Documents" }
      },
      {
        path: "/settings",
        name: "Settings",
        component: () => import("../views/pages/settings/settings.vue"),
        meta: { title: "Settings" }
      },
      ...crudRouteCreation("Users", "users"),
      {
        path: "/company/profile",
        name: "Company profile",
        component: () => import("../views/pages/company-profile/details.vue"),
        meta: { titleKey: "company-profile.route" }
      },
      {
        path: "/profile",
        name: "User profile",
        component: () => import("../views/pages/profile/view.vue"),
        meta: { titleKey: "profile.route" }
      },
      {
        path: "/invite",
        name: "InviteAuthenticated",
        component: () => import("../views/pages/invite/InviteAuthenticated.vue"),
        meta: { title: "Invite", allowUnauthenticated: false }
      },
      ...testComponentRoutes
    ]
  },
  {
    component: () => import("../views/layouts/Authenticated.vue"),
    children: [
      {
        path: "/tmp",
        name: "Temporary",
        component: () => import("../views/pages/tmp/overview.vue"),
        meta: { title: "Temporary" }
      },
      {
        path: "/tmp/notifications",
        name: "Temporary.Notifications",
        component: () => import("../views/pages/tmp/notifications/NotificationsPoc.vue"),
        meta: { title: "Notifications POC" }
      },
      {
        path: "/tmp/customers",
        name: "Temporary.Customers",
        component: () => import("../views/pages/tmp/customers/list.vue"),
        meta: { title: "Customers" }
      },
      {
        path: "/tmp/customers/create",
        name: "Temporary.Customers.Create",
        component: () => import("../views/pages/tmp/customers/create.vue"),
        meta: { title: "Create customer" }
      },
      {
        path: "/tmp/customers/details/:id",
        name: "Temporary.Customers.Profile",
        component: () => import("../views/pages/tmp/customers/tenantCompanyDetails.vue"),
        meta: { title: "Customer profile" }
      },
      {
        path: "/tmp/customers/edit/:id",
        name: "Temporary.Customers.Edit",
        component: () => import("../views/pages/tmp/customers/create.vue"),
        meta: { title: "Edit customer" }
      },
      {
        path: "/tmp/users",
        name: "Temporary.Users",
        component: () => import("../views/pages/tmp/users/list.vue"),
        meta: { title: "Users" }
      },
      {
        path: "/tmp/finance/job-mails",
        name: "Temporary.Finance.JobMails",
        component: () => import("../views/pages/tmp/finance/JobMailsView.vue"),
        meta: { title: "Job mails" }
      },
      {
        path: "/tmp/finance/invoice-ubl-embed",
        name: "Temporary.Finance.InvoiceUblEmbed",
        component: () => import("../views/pages/tmp/finance/InvoiceUblEmbedView.vue"),
        meta: { title: "Invoice UBL Embed" }
      },
      {
        path: "/tmp/finance/payment-notices",
        name: "Temporary.Finance.PaymentNotices",
        component: () => import("../views/pages/tmp/finance/PaymentNoticesView.vue"),
        meta: { title: "Payment notices" }
      },
      {
        path: "/tmp/finance/invoiced-companies-stats",
        name: "Temporary.Finance.InvoicedCompaniesStats",
        component: () => import("../views/pages/tmp/finance/InvoicedCompaniesStatsView.vue"),
        meta: { title: "Invoiced companies stats" }
      },
      {
        path: "/tmp/tests/stress",
        name: "Temporary.Tests.Stress",
        component: () => import("../views/pages/tmp/tests/StressTestView.vue"),
        meta: { title: "Stress tests" }
      }
    ]
  }
]
